<template>
  <v-container class="pa-0 border">
    <v-data-table
      :headers="headers"
      :items="previouslyCertifiedTotal"
      hide-default-footer
      hide-default-header
      density="compact"
    >
      <template
        v-slot:[`item.${header.value}`]="{ item }"
        v-for="(header, index) in headers"
      >
        <td
          :class="getColumnClass(index)"
          :style="{
            backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.WHITE,
            fontWeight: 500
          }"
          :key="`${item.id}-${header.value}`"
        >
          {{ formatValue(item[header.value]) }}
        </td>
      </template>
    </v-data-table>
    <v-data-table
      :headers="headers"
      :items="currentCertificationTotal"
      hide-default-footer
      hide-default-header
      density="compact"
    >
      <template
        v-slot:[`item.${header.value}`]="{ item }"
        v-for="(header, index) in headers"
      >
        <td
          :class="getColumnClass(index)"
          :style="{
            backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.WHITE,
            fontWeight: 500,
          }"
          :key="`${item.id}-${header.value}`"
        >
        {{ formatValue(item[header.value]) }}
      </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getColumnClass, formatValue, PAYMENT_CERTIFICATE_TABLE_COLOR } from '@/helpers'
export default {
  props: {
    headers: Array,
    previouslyCertifiedTotal: Array,
    currentCertificationTotal: Array
  },
  data () {
    return {
      formatValue,
      getColumnClass,
      PAYMENT_CERTIFICATE_TABLE_COLOR
    }
  }
}
</script>
